<template>
    <div>
        <CuentaAtras @tiempoTerminado="tiempoTerminado"/>
        <PageTitle 
            :title="$t('nuevo_abono.titulo', { temporada: lista_abonados.nombre, abono: teatro.texto_abono })" 
            class="strech"
        />
        <section class="padding-vertical-content">
            <Stepper 
                ref="stepper"
                :steps="steps" 
            >
                <template #pasoSector="{ changeStep }">
                    <SeleccionarZonaComponent
                        @zonaSeleccionada="(zona) => { 
                            zona_seleccionada = zona; 
                            changeStep(); 
                        }"
                        :sga_event_id="lista_abonados.sga_event_id"
                    />                   
                </template>
                <template #pasoAsiento="{ changeStep }">
                    <SeleccionarAsientosSga
                        tipo="abonos"
                        :zona="zona_seleccionada"
                        @sesionCreada="onSesionCreada"
                        @volver="() => {
                            zona_seleccionada = null;
                            eliminarDatos();
                            changeStep(true);
                        }"
                        :sga_event_id="lista_abonados.sga_event_id"
                        :sga_product_id="lista_abonados.sga_product_id"
                    />
                </template>
                <template #pasoDatos="{ changeStep }">
                    <DatosAbonosSGAComponent
                        :items_carrito="items_carrito"
                        :datos_abonos="datos_abonos"
                        @fillDatosAbonos="(datosAbonos) => { datos_abonos = datosAbonos }"
                        @setDatosCobro="(jet_id, formulario, session_id, cart_id) => {
                            setDatosCobro(jet_id, formulario, session_id, cart_id);
                            changeStep();
                        }"
                        @volver="() => {
                            eliminarDatos();
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoResumen="{ changeStep }">
                    <ResumenCompraComponent
                        :items="items_carrito"
                        :jet_id="jet_id"
                        :formulario="formulario"
                        :cart_id="cart_id"
                        @setDatosCobro="setDatosCobro"
                        @terminado="() => {
                            changeStep();
                        }"
                        @volver="() => {
                            changeStep(true);
                        }"
                    />
                </template>
                <template #pasoTarjeta>
                    <ProcesarPago 
                        :jet_id="jet_id"
                        :session_id="session_id"
                        @terminado="() => {
                            changeStep();
                        }"
                    />
                </template>
            </Stepper>
        </section>
    </div>
</template>

<script>
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import Stepper from '@/components/frontend/events/compra/components/Stepper.vue';
    import SeleccionarZonaComponent from './SeleccionarZonaComponent.vue';
    import SeleccionarAsientosSga from './SeleccionarAsientosSga.vue';
    import DatosAbonosSGAComponent from './DatosAbonosSGAComponent';
    import ResumenCompraComponent from '@/components/frontend/components/sga/ResumenCompraComponent.vue';
    import ProcesarPago from './ProcesarPago';

    export default {

        data() {
            return {
                zona_seleccionada: null,
                items_carrito: null,
                session_id: null,
                formulario: null,
                jet_id: null,
                cart_id: null,
                datos_abonos: []
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            },
            steps() {
                return [
                    { label: this.$t('abonados.seleccionar_sector'), slot: 'pasoSector' },
                    { label: this.$t('abonados.seleccionar_asientos'), slot: 'pasoAsiento' },
                    { label: this.$t('abonados.rellenar_datos'), slot: 'pasoDatos' },
                    { label: this.$t('abonados.resumen'), slot: 'pasoResumen' }
                ]
            }
        },
        methods: {
            tiempoTerminado() {
                this.eliminarDatos();
                this.$refs.stepper.changeStep(false, true);
            },
            eliminarDatos() {
                if (this.cart_id) {
                    this.$store.dispatch(this.config.getVuexAlias('sga.cart.eliminar-datos'), { cart_id: this.cart_id }).then(() => {
                        this.datos_abonos = [];
                        this.items_carrito = null;
                        this.cart_id = null;
                    }).catch(error => {
                        console.log('Error al eliminar los datos:', error);
                    });
                }
                localStorage.removeItem('sga_abono_cart_id');
            },
            setDatosCobro(jet_id, formulario, session_id, cart_id) {
                this.jet_id = jet_id;
                this.formulario = formulario;
                this.session_id = session_id;
                this.cart_id = cart_id;
            },
            onSesionCreada(items, carrito_id) {
                this.items_carrito = items;
                this.cart_id = carrito_id;
                this.setDatosAbonos();
                this.$refs.stepper.changeStep();
            },
            setDatosAbonos() {
                this.items_carrito?.forEach(item => {
                    this.datos_abonos.push({
                        id: item.id,
                        name: "",
                        lastName: "",
                        gender: "",
                        gender_object: null,
                        identification: {
                            type: "",
                            value: ""
                        },
                        address: {
                            country: "",
                            city: "",
                            state: "",
                            zipCode: "",
                            streetLine1: ""
                        },
                        birthday: "",
                        email: "",
                        email_confirm: "",
                        phone: "",
                        error_telefono: 0
                    });
                });
            }
        },
        mounted() {
            this.eliminarDatos();

            if (this.teatro.tipo_tpv === 2) {
                this.steps.push({ label: "Datos de pago", slot: "pasoTarjeta" });
            }
        },
        components: {
            CuentaAtras, PageTitle, Stepper, SeleccionarZonaComponent, SeleccionarAsientosSga, DatosAbonosSGAComponent, ResumenCompraComponent, ProcesarPago
        }
    }
</script>